import { Box, Button, IconButton, Modal, Typography } from '@material-ui/core';
import React, { useCallback } from 'react';
import { BiX } from 'react-icons/bi';
import { IoIosWarning } from 'react-icons/io';
import { Content, Header } from './styles';
import stylesMaterial from './stylesMaterial';
import { ComplementItem } from '../../../../../../../hooks/complements';

interface ConfirmUpdateAllModalProps {
  isOpen: boolean;
  handleClose: () => void;
  handleChangeComplementItem: (complementItem: Partial<ComplementItem>) => void;
  complementItem: ComplementItem;
}

export function ConfirmUpdateAllModal({
  isOpen,
  handleClose,
  handleChangeComplementItem,
  complementItem,
}: ConfirmUpdateAllModalProps) {
  const classes = stylesMaterial();

  const handleComplementChange = useCallback((updateAll: boolean) => {
    console.log(complementItem, updateAll)
    handleChangeComplementItem({
      id: complementItem.id,
      pauseSale: !complementItem.pauseSale,
      updateAll,
    });
    handleClose();
  }, [complementItem, handleChangeComplementItem]);

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      className={classes.modal}
      style={{
        zIndex: 99999991
      }}
    >
      <Box className={classes.container}>
        <Header>
          <IconButton
            onClick={handleClose}
            aria-label="close modal"
            className={classes.closeButton}
          >
            <BiX size="22px" />
          </IconButton>
        </Header>

        <Content>
          <Box className={classes.warningIconWrapper}>
            <IoIosWarning color="#f64444" fontSize="3.125rem" />
          </Box>

          <Typography id="modal-title" variant="h1" className={classes.title}>
            Atenção
          </Typography>

          <Typography id="modal-description" className={classes.description}>
            Deseja atualizar todos os complementos com o mesmo código?
          </Typography>

          <Button
            fullWidth
            onClick={() => handleComplementChange(true)}
            className={`${classes.button} ${classes.confirmButton}`}
          >
            Sim
          </Button>
          <Button
            fullWidth
            variant="outlined"
            onClick={() => handleComplementChange(false)}
            className={`${classes.button} ${classes.cancelButton}`}
          >
            Não
          </Button>
        </Content>
      </Box>
    </Modal>
  );
}
